<template>
    <BreadCrumb PageTitle="Liste des catégories d'articles" />
    <ListeCategorieArticle/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeCategorieArticle from "../../components/CategorieArticle/ListeCategorieArticle.vue";

    export default defineComponent({
      name: "ListeCategorieArticlePage",
      components: { 
        BreadCrumb,
        ListeCategorieArticle,
      },
    });
  </script>